import axios from 'axios';
import { customSortByKey } from './CustomFunctions';
import { BASE_URL } from '../config/axios';
import { Quill } from 'react-quill';

const FormSelectCSS = {
    control: (provided) => ({
        ...provided,
        width: '33vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        borderRadius: '10px',
        marginTop: '0',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
}

const CSSForSelectSmallWidth = {
    control: (provided) => ({
        ...provided,
        width: '30vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '20vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#cce4ff'
            : state.isSelected
                ? '#f7f8fa'
                : '#ffffff',
        color: '#4a4a4a',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};

const CSSForSelect10vWWidth = {
    control: (provided) => ({
        ...provided,
        width: '10vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '10vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? '#cce4ff'
            : state.isSelected
                ? '#f7f8fa'
                : '#ffffff',
        color: '#4a4a4a',
        cursor: 'pointer',
        ':active': {
            backgroundColor: '#cce4ff',
        },
    }),
};

const CSSForDropdownFilter = {
    control: (provided) => ({
        ...provided,
        color: '#707070',
        // backgroundColor: "transparent",
        outline: 'none',
        border: "none",
        padding: "0.6rem 0.5rem",
        textTransform: "capitalize",
        width: "11vw",
        boxShadow: 'none',
        '&:hover': {
            border: 'none',
        },
    }),
    placeholder: (provided) => ({ ...provided, color: "#707070" }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    singleValue: (provided) => ({ ...provided, color: "#707070" }),
    dropdownIndicator: (provided) => ({
        ...provided,
        filter: "invert(50%)",
        cursor: "pointer",
        left: "9.5rem",
        // width: "20px",
        height: "20px",
        // fontSize: "12px",
    }),
    option: (provided, state) => ({
        ...provided,
        // fontSize: "12px",
        color: state.isSelected ? '#2576bc' : '#707070',
        // color: state.isSelected ? "#ffffff" : "#707070",
        backgroundColor: state.isSelected ? '#2576bc' : 'white',
        // backgroundColor: state.isSelected ? "#2576bc" : state.isFocused ? "#ffffff" : "#fff",
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#2576bc',
            color: 'white',
        },
    }),
}

const CSSForDropdownFilter2 = {
    control: (provided) => ({
        ...provided,
        color: '#707070',
        outline: 'none',
        border: 'none',
        padding: '0.6rem 0.5rem',
        textTransform: 'capitalize',
        boxShadow: 'none',
        '&:hover': {
            border: 'none',
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#707070',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#707070',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        filter: 'invert(50%)',
        cursor: 'pointer',
        left: '9.5rem',
        width: '20px',
        height: '20px',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999, // Ensure dropdown menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? '#2576bc' : '#707070',
        backgroundColor: state.isSelected ? 'rgba(37,118,188,0.1)' : 'white',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#2576bc',
            color: 'white',
        },
    }),
}


const CSSForFilterDropdown = {
    control: (provided) => ({
        ...provided,
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
        // padding: "0.6rem 0.5rem",
        textTransform: "capitalize",
        // width: "11vw"
    }),
    placeholder: (provided) => ({ ...provided, color: "#707070" }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    singleValue: (provided) => ({ ...provided, color: "#707070" }),
    dropdownIndicator: (provided) => ({
        ...provided,
        filter: "invert(50%)",
        cursor: "pointer",
        left: "9.5rem",
        // width: "20px",
        // height: "20px",
        fontSize: "12px",
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: "12px",
        color: state.isSelected ? "#ffffff" : "#707070",
        backgroundColor: state.isSelected ? "#2576bc" : state.isFocused ? "#ffffff" : "#fff",
        cursor: "pointer",
        "&:hover": { backgroundColor: "#2576bc", color: "#fff" },
    }),
}

const CSSForSelect = {
    control: (provided) => ({
        ...provided,
        width: '33vw',
        minWidth: '33vw',
        minHeight: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
        // textTransform: "capitalize",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        // textTransform: "capitalize",
    }),
    menu: (provided) => ({
        ...provided,
        width: '33vw',
        minWidth: '33vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuList: (provided) => ({
        ...provided,
        width: '33vw',
        minWidth: '33vw',
        padding: 0,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        // textTransform: "capitalize",
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        // textTransform: "capitalize",
    }),
    option: (provided, state) => ({
        ...provided,
        // textTransform: "capitalize",
        backgroundColor: state.isFocused ? "#e6f0ff" : "#fff",
        color: '#4a4a4a',
    }),
};

const CSSForSelectAutoSize = {
    control: (provided) => ({
        ...provided,
        // width: '33vw',
        // minWidth: '33vw',
        minHeight: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px -20px 5px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        textTransform: "capitalize",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    menu: (provided) => ({
        ...provided,
        width: '33vw',
        minWidth: '33vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuList: (provided) => ({
        ...provided,
        width: '33vw',
        minWidth: '33vw',
        padding: 0,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    option: (provided, state) => ({
        ...provided,
        textTransform: "capitalize",
        backgroundColor: state.isFocused ? "#e6f0ff" : "#fff",
        color: '#4a4a4a',
    }),
};


const CustomCSSForSearchableSelect = {
    control: (provided) => ({
        ...provided,
        width: '33vw',
        minHeight: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        // margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
        cursor: 'pointer',
        boxShadow: 'none',
        '&:hover': {
            border: '1px solid #e3e3e3',
        }
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        fontSize: '14px',
    }),
    menu: (provided) => ({
        ...provided,
        borderRadius: '10px',
        width: '34vw',
        // marginTop: '5px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isDisabled ? '#f5f5f5' : (state.isFocused ? '#f0f0f0' : 'white'),
        color: state.isDisabled ? '#999999' : '#4a4a4a',
        cursor: state.isDisabled ? 'not-allowed' : 'pointer',
        '&:hover': {
            backgroundColor: state.isDisabled ? '#f5f5f5' : '#f0f0f0',
        },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '33vw',
        padding: '10px 10px',
        fontSize: '14px',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        // padding: '0 8px',
        '&:hover': {
            color: '#4a4a4a'
        }
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        // padding: '0 8px',
        '&:hover': {
            color: '#4a4a4a'
        }
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0',
    })

}



const SizeStyle = Quill.import("attributors/style/size");

SizeStyle.whitelist = [
    "10px",
    "12px",
    "14px",
    "16px",
    "18px",
    "24px",
    "32px",
    "42px"
];


Quill.register(SizeStyle, true);



// const Parchment = Quill.import("parchment");

// //  Create custom line-height style
// class LineHeightStyle extends Parchment.Attributor.Style { }

// const lineHeightStyle = new LineHeightStyle(
//     "lineheight",     // format name
//     "line-height",    // CSS property
//     {
//         scope: Parchment.Scope.BLOCK,
//         whitelist: ["1", "1.2", "1.5", "1.8", "2", "2.5", "3"],
//     }
// );


// Quill.register(lineHeightStyle, true);

// ===== Table toolbar handler (grid popup) =====

const BlockEmbed = Quill.import('blots/block/embed');

let lastFocusedTableCell = null;
let lastTableSelectionRange = null;

class TableBlot extends BlockEmbed {
    static create(value) {
        const node = super.create();
        node.setAttribute('contenteditable', 'false');
        node.setAttribute('class', 'ql-table-embed');
        node.innerHTML = value;
        TableBlot.setupTable(node);
        return node;
    }

    static setupTable(node) {
        node.querySelectorAll('th').forEach(th => {
            const td = document.createElement('td');

            while (th.firstChild) {
                td.appendChild(th.firstChild);
            }

            td.setAttribute('contenteditable', 'true');
            th.replaceWith(td);
        });

        node.querySelectorAll('td').forEach(cell => {
            cell.setAttribute('contenteditable', 'true');
            cell.style.fontWeight = 'normal';
            cell.style.backgroundColor = 'transparent';

            const saveFocus = () => {
                lastFocusedTableCell = cell;
                const selection = window.getSelection ? window.getSelection() : null;
                if (selection && selection.rangeCount) {
                    lastTableSelectionRange = selection.getRangeAt(0).cloneRange();
                }
            };

            cell.addEventListener('mousedown', saveFocus);
            cell.addEventListener('mouseup', saveFocus);
            cell.addEventListener('keyup', saveFocus);
            cell.addEventListener('focus', saveFocus);
        });

        const selectionChangeHandler = () => {
            const selection = window.getSelection ? window.getSelection() : null;
            if (!selection || !selection.rangeCount) return;
            const range = selection.getRangeAt(0);
            const cell = getAncestorTableCell(range.startContainer);
            if (cell && node.contains(cell)) {
                lastFocusedTableCell = cell;
                lastTableSelectionRange = range.cloneRange();
            }
        };

        document.addEventListener('selectionchange', selectionChangeHandler);
        node.__selectionChangeHandler = selectionChangeHandler;

        // Notify Quill of changes inside cells
        node.addEventListener('input', () => {
            const container = node.closest('.ql-container');
            if (container && container.__quill) container.__quill.update('user');
        });

        // Tab key navigation between cells
        node.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                const cells = Array.from(node.querySelectorAll('td'));
                const current = document.activeElement;
                const idx = cells.indexOf(current);
                if (idx === -1) return;
                const next = e.shiftKey ? cells[idx - 1] : cells[idx + 1];
                if (next) { next.focus(); }
            }
        });

        // Right-click context menu
        node.addEventListener('contextmenu', (e) => {
            const cell = e.target.closest('td');
            if (!cell) return;
            e.preventDefault();
            showTableContextMenu(e.clientX, e.clientY, cell, node);
        });
    }

    static value(node) {
        const clone = node.cloneNode(true);
        clone.querySelectorAll('[contenteditable]').forEach(el => el.removeAttribute('contenteditable'));
        clone.removeAttribute('contenteditable');
        clone.removeAttribute('class');
        return clone.innerHTML;
    }
}
TableBlot.blotName = 'table-embed';
TableBlot.tagName = 'TABLE';
Quill.register(TableBlot, true);

// ===== Table Context Menu =====
function showTableContextMenu(x, y, cell, tableNode) {
    // Remove any existing context menu
    const old = document.querySelector('.ql-table-context-menu');
    if (old) old.remove();

    const menu = document.createElement('div');
    menu.className = 'ql-table-context-menu';
    menu.style.cssText = `position:fixed;top:${y}px;left:${x}px;z-index:10001;`;

    const actions = [
        { icon: '⬆', label: 'Insert Row Above', action: () => insertRow(cell, 'before', tableNode) },
        { icon: '⬇', label: 'Insert Row Below', action: () => insertRow(cell, 'after', tableNode) },
        { icon: '⬅', label: 'Insert Column Left', action: () => insertCol(cell, 'before', tableNode) },
        { icon: '➡', label: 'Insert Column Right', action: () => insertCol(cell, 'after', tableNode) },
        { icon: '—', label: '', action: null }, // separator
        { icon: '🗑', label: 'Delete Row', action: () => deleteRow(cell, tableNode), danger: true },
        { icon: '🗑', label: 'Delete Column', action: () => deleteCol(cell, tableNode), danger: true },
        { icon: '—', label: '', action: null }, // separator
        { icon: '❌', label: 'Delete Table', action: () => deleteTable(tableNode), danger: true },
    ];

    actions.forEach(({ icon, label, action, danger }) => {
        if (!action) {
            const sep = document.createElement('div');
            sep.className = 'ql-table-ctx-sep';
            menu.appendChild(sep);
            return;
        }
        const item = document.createElement('div');
        item.className = `ql-table-ctx-item${danger ? ' ql-table-ctx-danger' : ''}`;
        item.innerHTML = `<span class="ql-table-ctx-icon">${icon}</span>${label}`;
        item.addEventListener('click', () => { action(); menu.remove(); });
        menu.appendChild(item);
    });

    document.body.appendChild(menu);

    // Adjust position if overflowing viewport
    const rect = menu.getBoundingClientRect();
    if (rect.right > window.innerWidth) menu.style.left = `${window.innerWidth - rect.width - 8}px`;
    if (rect.bottom > window.innerHeight) menu.style.top = `${window.innerHeight - rect.height - 8}px`;

    setTimeout(() => {
        const close = (e) => {
            if (!menu.contains(e.target)) { menu.remove(); document.removeEventListener('mousedown', close); }
        };
        document.addEventListener('mousedown', close);
    }, 0);
}

function notifyQuill(tableNode) {
    const container = tableNode.closest('.ql-container');
    if (container && container.__quill) container.__quill.update('user');
}

function getAncestorTableCell(node) {
    while (node) {
        if (node.nodeType === 1 && (node.tagName === 'TD' || node.tagName === 'TH')) return node;
        node = node.parentNode;
    }
    return null;
}

function restoreTableSelectionRange() {
    if (!window.getSelection || !lastTableSelectionRange) return false;
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(lastTableSelectionRange);
    return true;
}

function getSelectedTableCell(quill) {
    if (!quill) return null;

    const selection = window.getSelection ? window.getSelection() : null;
    let node = null;

    if (selection && selection.anchorNode) {
        node = selection.anchorNode;
    } else {
        const range = quill.getSelection();
        if (range) {
            const [leaf] = quill.getLeaf(range.index);
            if (leaf && leaf.domNode) node = leaf.domNode;
        }
    }

    node = node || document.activeElement;
    const selectedCell = node ? getAncestorTableCell(node) : null;
    return selectedCell || lastFocusedTableCell;
}

function applyTableSelectionFormat(format, value) {
    if (!window.getSelection) return false;

    const selection = window.getSelection();
    if (!selection.rangeCount || !getAncestorTableCell(selection.anchorNode)) {
        if (!restoreTableSelectionRange()) return false;
    }

    const range = selection.rangeCount ? selection.getRangeAt(0) : null;
    const cell = range ? getAncestorTableCell(range.commonAncestorContainer || range.startContainer) : null;
    if (!cell) return false;

    const commandMap = {
        bold: 'bold',
        italic: 'italic',
        underline: 'underline',
        strike: 'strikeThrough',
        color: 'foreColor',
        background: 'hiliteColor',
        font: 'fontName',
        size: 'fontSize',
    };

    const command = commandMap[format];
    if (!command) return false;

    document.execCommand(command, false, value);
    lastFocusedTableCell = cell;
    if (selection.rangeCount) {
        lastTableSelectionRange = selection.getRangeAt(0).cloneRange();
    }

    return true;
}

function handleToolbarTableAction(action, quill) {
    const cell = getSelectedTableCell(quill);
    if (!cell) return;
    const tableNode = cell.closest('table');
    if (!tableNode) return;

    switch (action) {
        case 'insertRowAbove':
            insertRow(cell, 'before', tableNode);
            break;
        case 'insertRowBelow':
            insertRow(cell, 'after', tableNode);
            break;
        case 'insertColLeft':
            insertCol(cell, 'before', tableNode);
            break;
        case 'insertColRight':
            insertCol(cell, 'after', tableNode);
            break;
        case 'deleteRow':
            deleteRow(cell, tableNode);
            break;
        case 'deleteCol':
            deleteCol(cell, tableNode);
            break;
        default:
            break;
    }
}

function insertRow(cell, position, tableNode) {
    const row = cell.closest('tr');
    const colCount = row.children.length;
    const newRow = document.createElement('tr');
    for (let i = 0; i < colCount; i++) {
        const td = document.createElement('td');
        td.setAttribute('contenteditable', 'true');
        td.innerHTML = '\u00A0';
        newRow.appendChild(td);
    }
    row.parentNode.insertBefore(newRow, position === 'before' ? row : row.nextSibling);
    notifyQuill(tableNode);
}

function insertCol(cell, position, tableNode) {
    const row = cell.closest('tr');
    const colIdx = Array.from(row.children).indexOf(cell);
    Array.from(tableNode.querySelectorAll('tr')).forEach(tr => {
        const td = document.createElement('td');
        td.setAttribute('contenteditable', 'true');
        td.innerHTML = '\u00A0';
        const ref = tr.children[position === 'before' ? colIdx : colIdx + 1];
        tr.insertBefore(td, ref || null);
    });
    notifyQuill(tableNode);
}

function deleteRow(cell, tableNode) {
    const row = cell.closest('tr');
    if (tableNode.querySelectorAll('tr').length <= 1) { deleteTable(tableNode); return; }
    row.remove();
    notifyQuill(tableNode);
}

function deleteCol(cell, tableNode) {
    const row = cell.closest('tr');
    const colIdx = Array.from(row.children).indexOf(cell);
    if (row.children.length <= 1) { deleteTable(tableNode); return; }
    Array.from(tableNode.querySelectorAll('tr')).forEach(tr => {
        if (tr.children[colIdx]) tr.children[colIdx].remove();
    });
    notifyQuill(tableNode);
}

function deleteTable(tableNode) {
    const container = tableNode.closest('.ql-container');
    tableNode.remove();
    if (container && container.__quill) container.__quill.update('user');
}



function tableHandler() {
    const quill = this.quill;
    const existing = document.querySelector('.ql-table-popup');
    if (existing) { existing.remove(); return; }

    const btn = this.container.querySelector('.ql-insertTable');
    const rect = btn.getBoundingClientRect();

    const popup = document.createElement('div');
    popup.className = 'ql-table-popup';
    popup.style.cssText = `position:fixed;top:${rect.bottom + 4}px;left:${rect.left}px;z-index:10000;`;

    const title = document.createElement('div');
    title.className = 'ql-table-popup-title';
    title.textContent = 'Insert Table';
    popup.appendChild(title);

    const grid = document.createElement('div');
    grid.className = 'ql-table-popup-grid';

    const sizeLabel = document.createElement('div');
    sizeLabel.className = 'ql-table-popup-size';

    for (let r = 0; r < 10; r++) {
        for (let c = 0; c < 10; c++) {
            const cell = document.createElement('div');
            cell.className = 'ql-table-popup-cell';
            cell.dataset.row = r;
            cell.dataset.col = c;
            cell.addEventListener('mouseover', () => {
                grid.querySelectorAll('.ql-table-popup-cell').forEach(el => {
                    el.classList.toggle('active', parseInt(el.dataset.row) <= r && parseInt(el.dataset.col) <= c);
                });
                sizeLabel.textContent = `${r + 1} × ${c + 1}`;
            });
            cell.addEventListener('click', () => {
                let html = '<tbody>';
                for (let i = 0; i <= r; i++) {
                    html += '<tr>';
                    for (let j = 0; j <= c; j++) html += '<td>\u00A0</td>';
                    html += '</tr>';
                }
                html += '</tbody>';
                const range = quill.getSelection(true);
                const idx = range ? range.index : quill.getLength() - 1;
                quill.insertEmbed(idx, 'table-embed', html, 'user');
                quill.setSelection(idx + 1, 0, 'silent');
                popup.remove();
            });
            grid.appendChild(cell);
        }
    }

    popup.appendChild(grid);
    popup.appendChild(sizeLabel);

    setTimeout(() => {
        const close = (e) => {
            if (!popup.contains(e.target) && !btn.contains(e.target)) {
                popup.remove(); document.removeEventListener('mousedown', close);
            }
        };
        document.addEventListener('mousedown', close);
    }, 0);
    document.body.appendChild(popup);
}
// ===== End Table Feature =====
const QuillEditorModules = {
    toolbar: {
        container: [
            [{ font: [] }],
            [{ size: SizeStyle.whitelist }],
            // [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["link",
                // "image", "video"
            ],
            ["insertTable", "insertRowAbove", "insertRowBelow", "insertColLeft", "insertColRight"],
            // [{ lineheight: ["1", "1.2", "1.5", "1.8", "2", "2.5", "3"] }]
            ['blockquote', 'code-block'],

            ["clean"],
        ],
        handlers: {
            insertTable: tableHandler,
            insertRowAbove: function () { handleToolbarTableAction('insertRowAbove', this.quill); },
            insertRowBelow: function () { handleToolbarTableAction('insertRowBelow', this.quill); },
            insertColLeft: function () { handleToolbarTableAction('insertColLeft', this.quill); },
            insertColRight: function () { handleToolbarTableAction('insertColRight', this.quill); },
            bold: function (value) {
                if (!applyTableSelectionFormat('bold', value)) this.quill.format('bold', value);
            },
            italic: function (value) {
                if (!applyTableSelectionFormat('italic', value)) this.quill.format('italic', value);
            },
            underline: function (value) {
                if (!applyTableSelectionFormat('underline', value)) this.quill.format('underline', value);
            },
            strike: function (value) {
                if (!applyTableSelectionFormat('strike', value)) this.quill.format('strike', value);
            },
            color: function (value) {
                if (!applyTableSelectionFormat('color', value)) this.quill.format('color', value);
            },
            background: function (value) {
                if (!applyTableSelectionFormat('background', value)) this.quill.format('background', value);
            },
            font: function (value) {
                if (!applyTableSelectionFormat('font', value)) this.quill.format('font', value);
            },
            size: function (value) {
                if (!applyTableSelectionFormat('size', value)) this.quill.format('size', value);
            },
        },
    },
    clipboard: {
        matchers: [
            ['TABLE', (node) => {
                const Delta = Quill.import('delta');
                const clone = node.cloneNode(true);
                clone.querySelectorAll('[contenteditable]').forEach(el => el.removeAttribute('contenteditable'));
                return new Delta().insert({ 'table-embed': clone.innerHTML });
            }],
        ],
    },
    keyboard: {
        bindings: {
            preventVariableDelete: {
                key: "Backspace",
                handler: function (range, context) {
                    const quill = this.quill;
                    const text = quill.getText();

                    const cursorPos = range.index;

                    // Regex to match {{1}}, {{2}} etc
                    const regex = /{{\d+}}/g;
                    let match;

                    while ((match = regex.exec(text)) !== null) {
                        const start = match.index;
                        const end = start + match[0].length;

                        if (cursorPos > start && cursorPos <= end) {
                            return false; //  BLOCK deletion
                        }
                    }

                    return true; //  allow normal delete
                },
            },

            preventDeleteForward: {
                key: "Delete",
                handler: function (range, context) {
                    const quill = this.quill;
                    const text = quill.getText();

                    const cursorPos = range.index;

                    const regex = /{{\d+}}/g;
                    let match;

                    while ((match = regex.exec(text)) !== null) {
                        const start = match.index;
                        const end = start + match[0].length;

                        if (cursorPos >= start && cursorPos < end) {
                            return false; //  BLOCK delete
                        }
                    }

                    return true;
                },
            },
        },
    },
};

const QuillEditorFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "align",
    "list",
    "bullet",
    "indent",
    "link",
    // "image",
    // "video",
    "code-block",
    "blockquote",
    // "lineheight",
    "clean",
    "table-embed",
];
//tooltip content for letter format description
const toolTipContent = (
    <div className="tooltip-options-whitebg">
        <h4 className="">Note:</h4>
        <hr className="line" />
        <p> For alignment (e.g., placing content on left and right in the same line), you can use spaces carefully.
        </p>
        <ul className="tooltip-list">
            <li>Use moderate spacing — avoid adding too many spaces.</li>
            <li>Keep both texts short to prevent line wrapping.</li>
            <li>Check alignment using the Preview option before saving.</li>
            <li>Alignment may vary slightly in print or different screen sizes.</li>
            <li>Text alignment (left/center/right) applies to the entire line, not selected words.</li>
            <li className="note">For best results, keep formatting simple and consistent.</li>
        </ul>
    </div>
)

const getPageDimensionsPx = (pageSize) => {
    const dpi = 96; // standard screen resolution
    const mmToInch = 0.0393701;

    const sizes = {
        A4: { width: 210, height: 297 },
        A3: { width: 297, height: 420 },
        Letter: { width: 216, height: 279 },
    };

    const size = sizes[pageSize] || sizes.A4;

    return {
        width: size.width * mmToInch * dpi,
        height: size.height * mmToInch * dpi,
    };
};


const fetchExistingLetterTemplate = async ({ letterTemplateId, emp_code, subcompanyId }) => {
    try {
        // Case 1: by direct letterTemplateId
        if (letterTemplateId) {
            const { data } = await axios.get(
                `${BASE_URL}/wfm/letter-builder-template-byid/${letterTemplateId}/`
            );
            return { template: data, subcompany: null };
        }

        // Case 2: by employee-specific template
        if (emp_code) {
            const { data: employeeData } = await axios.get(
                `${BASE_URL}/wfm/ourcompanydetailsbyemp/${emp_code}/`
            );

            if (employeeData?.letter_template) {
                const { data } = await axios.get(
                    `${BASE_URL}/wfm/letter-builder-template-byid/${employeeData.letter_template}/`
                );
                return { template: data, subcompany: null };
            }
        }

        // Case 3: by subcompany template
        if (subcompanyId) {
            const { data: subcompany } = await axios.get(
                `${BASE_URL}/wfm/subcompany-by-id/${subcompanyId}/`
            );

            if (subcompany?.company_letter_template) {
                const { data: template } = await axios.get(
                    `${BASE_URL}/wfm/letter-builder-template-byid/${subcompany.company_letter_template}/`
                );
                return { template, subcompany };
            }

            return { template: null, subcompany };
        }

        throw new Error("No letter template found.");
    } catch (error) {
        console.error("Error in fetchExistingLetterTemplate:", error);
        throw error;
    }
};

// function numberToIndianWords(num) {
//     const ones = [
//         "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
//         "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//         "Seventeen", "Eighteen", "Nineteen"
//     ];
//     const tens = [
//         "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     if (isNaN(num) || !isFinite(num)) return "Zero";
//     if (num === 0) return "Zero";

//     const convert = (n) => {
//         let output = "";

//         const crore = Math.floor(n / 10000000);
//         if (crore > 0) {
//             output += convert(crore) + " Crore ";
//             n %= 10000000;
//         }

//         const lakh = Math.floor(n / 100000);
//         if (lakh > 0) {
//             output += convert(lakh) + " Lakh ";
//             n %= 100000;
//         }

//         const thousand = Math.floor(n / 1000);
//         if (thousand > 0) {
//             output += convert(thousand) + " Thousand ";
//             n %= 1000;
//         }

//         const hundred = Math.floor(n / 100);
//         if (hundred > 0) {
//             output += convert(hundred) + " Hundred ";
//             n %= 100;
//         }

//         if (n > 0) {
//             if (output) output += "and ";
//             if (n < 20) {
//                 output += ones[n];
//             } else {
//                 output += tens[Math.floor(n / 10)];
//                 if (n % 10 !== 0) output += " " + ones[n % 10];
//             }
//         }

//         return output.trim();
//     };

//     return convert(Math.floor(num));
// }
function numberToIndianWords(num) {
    const ones = [
        "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
        "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
        "Seventeen", "Eighteen", "Nineteen"
    ];

    const tens = [
        "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];

    if (isNaN(num) || !isFinite(num)) return "ZERO RUPEES ONLY";

    if (Number(num) === 0) return "ZERO RUPEES ONLY";

    const convert = (n) => {
        let output = "";

        const crore = Math.floor(n / 10000000);
        if (crore > 0) {
            output += convert(crore) + " Crore ";
            n %= 10000000;
        }

        const lakh = Math.floor(n / 100000);
        if (lakh > 0) {
            output += convert(lakh) + " Lakh ";
            n %= 100000;
        }

        const thousand = Math.floor(n / 1000);
        if (thousand > 0) {
            output += convert(thousand) + " Thousand ";
            n %= 1000;
        }

        const hundred = Math.floor(n / 100);
        if (hundred > 0) {
            output += convert(hundred) + " Hundred ";
            n %= 100;
        }

        if (n > 0) {
            if (output) output += "and ";
            if (n < 20) {
                output += ones[n];
            } else {
                output += tens[Math.floor(n / 10)];
                if (n % 10 !== 0) output += " " + ones[n % 10];
            }
        }

        return output.trim();
    };

    const integerPart = Math.floor(num);
    const decimalPart = Math.round((num - integerPart) * 100);

    let words = convert(integerPart) + " Rupees";

    if (decimalPart > 0) {
        words += " and " + convert(decimalPart) + " Paise";
    }

    words += " Only";

    return words.toUpperCase();
}

const getAvailableActions = (permission) => {
    switch (permission) {
        case "Approve-Reject-Edit":
            return { canEdit: true };

        case "Approve-Reject":
            return { canReject: true };

        case "Approve":
            return { canApprove: true };

        case "Finalize":
            return { canFinalize: true };

        case "Finalize-Edit":
            return { canFinalize: true, canEdit: true };

        default:
            return {};
    }
};

const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

const getPaperDimensions = (size) => {
    switch (size) {
        case "A4":
            return { width: "210mm", height: "293mm" };
        case "A3":
            return { width: "297mm", height: "419.5mm" };
        case "letter":
            return { width: "216mm", height: "279mm" };
        default:
            return { width: "210mm", height: "297mm" };
    }
};

const parsePadding = (value) => {
    if (value === undefined || value === null || value === '') {
        return 0;
    }
    return parseInt(value.toString().replace('px', ''), 10);
};

const getImageSource = (image) => {
    if (!image) return null;
    return image instanceof File ? URL.createObjectURL(image) : image;
};

const formatContentForPrint = (content) => {
    if (!content) return "";
    // Strip any contenteditable attributes so they don't persist in preview/print
    let formatted = content.replace(/contenteditable="[^"]*"/g, "");

    return formatted
        .replace(/\n\n/g, "</p><p>")
        .replace(/\n/g, "<br>")
        .replace(/<p><\/p>/g, "")
        .replace(/<p>\s*<\/p>/g, "");
};



const lineHeightOptions = Array.from({ length: 11 }, (_, i) => {
    const num = Number((1 + i * 0.1).toFixed(1));
    return {
        label: num === 1 ? "1" : num.toString(),
        value: num,
    };
});


const staticVariableOptions = [
    { value: "name", label: "Name" },
    { value: "emp_code", label: "Employee Code" },
    { value: "department_name", label: "Department" },
    { value: "designation_name", label: "Designation" },
    { value: "division_name", label: "Division" },
    { value: "joining_date", label: "Joining Date" },
    { value: "employee_status", label: "Employee Status" },
    { value: "employee_type", label: "Employee Type" },
    { value: "location_name", label: "Location" },
    { value: "rh_name", label: "Reporting Head" },
    { value: "user_detail", label: "Email" },
    { value: "contact_number", label: "Contact Number" },
    { value: "mobile_number", label: "Mobile Number" }
];

const MONTH_OPTIONS = [
    { value: "1", label: "January" }, { value: "2", label: "February" },
    { value: "3", label: "March" }, { value: "4", label: "April" },
    { value: "5", label: "May" }, { value: "6", label: "June" },
    { value: "7", label: "July" }, { value: "8", label: "August" },
    { value: "9", label: "September" }, { value: "10", label: "October" },
    { value: "11", label: "November" }, { value: "12", label: "December" },
];

// appraisal workflow logic 
// appraisalWorkflowUtils.js

export const APPRAISAL_SECTIONS = {
    PERFORMANCE: "performance",
    DISCIPLINE: "discipline & behaviour",
    TEAM_PERFORMANCE: "team performance",
};

const LEVEL1_ONLY_SECTIONS = [
    APPRAISAL_SECTIONS.PERFORMANCE,
    APPRAISAL_SECTIONS.DISCIPLINE,
];

const normalizeSection = (s) => s?.trim()?.toLowerCase();

// Which sections can a given level rate?
// Level 1 (and NOT the only/last level) => Performance + Discipline only
// Everyone else (level 2..N, or level 1 when it's also the only level) => all 3
export const getSectionsForLevel = (level, totalLevels) => {
    const isOnlyLevel = totalLevels === 1;
    if (level === 1 && !isOnlyLevel) return LEVEL1_ONLY_SECTIONS;
    return "ALL";
};

export const isSectionEditableForLevel = (sectionName, level, totalLevels) => {
    const allowed = getSectionsForLevel(level, totalLevels);
    if (allowed === "ALL") return true;
    return allowed.includes(normalizeSection(sectionName));
};

// level_wise_ratings -> quick lookup by level number
export const indexByLevel = (levelWiseRatings = []) => {
    const map = {};
    levelWiseRatings.forEach((l) => { map[l.level] = l; });
    return map;
};

export const isFinalized = (levelWiseRatings, totalLevels) => {
    const byLevel = indexByLevel(levelWiseRatings);
    return byLevel[totalLevels]?.status === "finalized";
};

// Employee can edit self-rating only until Level 1 has submitted anything
export const isEmployeeEditable = (levelWiseRatings) => {
    const byLevel = indexByLevel(levelWiseRatings);
    return !byLevel[1];
};

// A given approval level is editable if:
// - overall appraisal isn't finalized, AND
// - it's the last level (always open till finalize), OR the next level hasn't submitted yet
export const isLevelEditable = (level, levelWiseRatings, totalLevels) => {
    if (isFinalized(levelWiseRatings, totalLevels)) return false;
    if (level === totalLevels) return true;
    const byLevel = indexByLevel(levelWiseRatings);
    return !byLevel[level + 1];
};

// Prefill marks for a level:
// - Level 1: nothing (fresh entry)
// - Level 2+: previous level's marks_by_authority (falls back to employee self marks
//   if, for some reason, previous level record isn't there yet)
export const getPrefillForLevel = (level, levelWiseRatings, selfRatings = []) => {
    const map = {};
    if (level === 1) return map;

    const byLevel = indexByLevel(levelWiseRatings);
    const prevEntry = byLevel[level - 1];

    if (prevEntry) {
        prevEntry.ratings.forEach((r) => { map[r.rating_id] = r.marks_by_authority; });
    } else {
        selfRatings.forEach((r) => { map[r.id] = r.employee_marks; });
    }
    return map;
};

// If this approver already has an entry at this level (editing their own earlier submit)
export const getMyExistingEntry = (level, levelWiseRatings) =>
    indexByLevel(levelWiseRatings)[level] || null;

// All levels a given emp_code is approver for, in this employee's resolved hierarchy.
// Handles the "same person is RH and ADMIN" case naturally — returns both levels.
export const resolveMyLevels = (hierarchy = [], myEmpCode) =>
    hierarchy.filter((h) => h.approver === myEmpCode).map((h) => h.level);

export const groupRatingsBySection = (ratings = []) => {
    const groups = {};
    ratings.forEach((r) => {
        const key = normalizeSection(r.question?.type) || "general";
        if (!groups[key]) groups[key] = { label: r.question?.type || "General", items: [] };
        groups[key].items.push(r);
    });
    return groups;
};


export {
    FormSelectCSS,

    CSSForSelect,
    CSSForSelectAutoSize,
    CSSForSelectSmallWidth,
    CSSForSelect10vWWidth,

    CSSForFilterDropdown,
    CSSForDropdownFilter,
    CSSForDropdownFilter2,

    CustomCSSForSearchableSelect,

    QuillEditorModules,
    QuillEditorFormats,

    getPageDimensionsPx,
    fetchExistingLetterTemplate,

    numberToIndianWords,
    getAvailableActions,
    monthNames,
    getPaperDimensions,
    parsePadding,
    getImageSource,
    formatContentForPrint,
    lineHeightOptions,
    toolTipContent,
    staticVariableOptions,
    MONTH_OPTIONS,
}